import { publicClient, apiClient } from './axiosInstance';
import { ensureOk } from '../helpers/api-helper';
import { ApiEnvelope } from '@/types/apiEnvelope';
import type { SearchUserStoreItem } from '@/types/search';

type SearchUserStoreData = {
  data: SearchUserStoreItem[];
  num: number;
};

export const SearchService = {
  async getUserStoreItem(
    keywords: string,
    page = 1,
    signal?: AbortSignal
  ): Promise<SearchUserStoreItem[]> {
    const kw = (keywords ?? '').trim();
    if (!kw) return []; // ✅ 避免後端 required: true 噴錯

    const { data } = await publicClient.get<ApiEnvelope<SearchUserStoreData>>(
      '/search/user_store',
      {
        params: {
          keywords: kw, // ✅ 後端要 keywords
          page, // ✅ 後端要 page（1 代表 0~20）
        },
        signal,
      }
    );

    const result = ensureOk<SearchUserStoreData>(data);
    return result.data ?? [];
  },
};
